export default "__VITE_ASSET__PSG13Ehj__"